import { getLeaderboardTrend } from '../utils/leaderboardUtils';
import { supabase } from '../supabaseClient';

const normalizeLeaderboardEntry = (entry) => ({
  ...entry,
  rating_history: Array.isArray(entry?.rating_history) ? entry.rating_history : [],
  rating_trend: entry?.rating_trend || getLeaderboardTrend(entry?.rating_history),
});

export const getLeaderboard = async (includeBots = false) => {
  // Try Edge Function with 30s in-memory cache first.
  // The UI paginates client-side, so this endpoint returns the full qualified leaderboard.
  try {
    const result = await supabase.functions?.invoke(`get-leaderboard?includeBots=${includeBots}`, {
      body: {},
    });
    if (result && !result.error && Array.isArray(result.data)) return result.data.map(normalizeLeaderboardEntry);
  } catch { /* Edge Function not deployed — fall through */ }

  // Fallback: direct Supabase query (Edge Functions may not be deployed in all envs)
  const { data, error } = await supabase
    .from('profiles')
    .select('username, wins, games_played, total_score, rating, is_bot, bot_persona, rating_history')
    .eq('is_bot', includeBots)
    .gte('games_played', 5)
    .order('rating', { ascending: false })
    .order('wins', { ascending: false });

  if (error) throw error;
  return (data || []).map(normalizeLeaderboardEntry);
};
